import { initClarity } from '@composables/tools/clarity.hook'

import { initAmplitude } from '@tools/amplitude'

export default defineNuxtRouteMiddleware(() => {
  initAmplitude()
  initClarity()
})
